import React from 'react';

import useServerSideRendering from '../../hooks/useServerSideRendering';
import useWindowSize from '../../hooks/useWindowSize';
import HorizentalTimePoint from './HorizentalTimePoint';
import VerticalTimePoint from './VerticalTimePoint';
import { TIME_LINE_EVENTS } from './timeLineEvents';

export interface EventProp {
  month: string;
  year: string;
  articleTitle: string;
  logoPath: string;
  articleLink?: string;
}

const TimeLine = () => {
  const { width: windowWidth } = useWindowSize();
  const hydrated = useServerSideRendering();

  return (
    <div className="tw-justify-center tw-mx-auto tw-flex ">
      <div className="tw-w-full tw-px-16">
        <>
          {hydrated &&
            (windowWidth < 1200
              ? TIME_LINE_EVENTS.map((events, index) => (
                  <>
                    <div
                      className="tw-ml-80 sm:tw-ml-[12rem] tw-relative tw-my-48"
                      key={events[0].articleTitle}
                    >
                      <div className="tw-w-px tw-h-[310px] sm:tw-h[380px] tw-bg-gray-300"></div>
                      <VerticalTimePoint events={events} />
                    </div>
                    {index < TIME_LINE_EVENTS.length - 1 ? (
                      <div className="sm:tw-mx-64 tw-border-0 tw-border-b tw-border-solid tw-border-gray-200"></div>
                    ) : (
                      <div className="sm:tw-mx-64 tw-border-0 tw-border-b-2 tw-border-solid tw-border-gray-300"></div>
                    )}
                  </>
                ))
              : TIME_LINE_EVENTS.map((events, index) => (
                  <div key={events[0].articleTitle}>
                    <div className="tw-flex tw-justify-center tw-px-[12rem] tw-mt-72">
                      <HorizentalTimePoint events={events} />
                    </div>
                    {index < TIME_LINE_EVENTS.length - 1 ? (
                      <div className="tw-mx-[12rem] tw-py-64 tw-border-0 tw-border-b tw-border-solid tw-border-gray-200"></div>
                    ) : (
                      <div className="tw-mx-[12rem] tw-py-64 tw-border-0 tw-border-b-2 tw-border-solid tw-border-gray-300"></div>
                    )}
                  </div>
                )))}
        </>
      </div>
    </div>
  );
};

export default TimeLine;
